import { render, staticRenderFns } from "./Porto.vue?vue&type=template&id=50f86a51"
import script from "./Porto.vue?vue&type=script&lang=js"
export * from "./Porto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports